const companyInformationEndpoints = {
  detail: (companyId: string) => `/companies/${companyId}/information` as const,
  stakeholders: (companyId: string) => `/companies/${companyId}/information/stakeholders` as const
}

export default companyInformationEndpoints
